module.exports = __webpack_public_path__ + "static/media/transport-icon.4a68e632.svg";